import React, { Component } from 'react'
import '../styles/ClusterProfile.css'
import DropdownWidget from '../widgets/DropdownWidget'
import InputSearchWidget from '../widgets/InputSearchWidget'
import Board from '../widgets/Board'
import Card from '../widgets/Card'
import OrgFooter from '../widgets/OrgFooter'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import DatePicker from '../widgets/DatePicker'
import APIGenericRequest from '../api/APIGenericRequest'
import APIClusterRequest from '../api/APIClusterRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'

class ClusterProfile extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			clusterId: sessionStorage.getItem("cluster-id"),
			siteId: localStorage.getItem("siteId"),
			dateToday: sessionStorage.getItem("date-today"),
			isViewDetails: props.isViewDetails,
			province: "-- SELECT --",
			city: "-- SELECT --",
			barangay: "-- ANY --",
			members: {},
			draggable: props.isViewDetails,
			shouldDisplayValues: props.displayValues
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.addMember = this.addMember.bind(this)
		this.getProvinces = this.getProvinces.bind(this)
		this.getFormValues = this.getFormValues.bind(this)
		this.getAllBarangaysByCityId = this.getAllBarangaysByCityId.bind(this)
		this.addCluster = this.addCluster.bind(this)
		this.editCluster = this.editCluster.bind(this)
		this.onSearchEvent = this.onSearchEvent.bind(this)
		this.getAllFarmersBySiteId = this.getAllFarmersBySiteId.bind(this)
		this.archiveCluster = this.archiveCluster.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		if(this.state.clusterName == null || this.state.clusterName == '') {
			this.setState({
				showWarningMessage: true,
				aMessage: "Cluster name required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.dateFormed == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Date formed is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.provinceId == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "Province is required.",
				showActivityIndicator: false
			})
			return
		}
		if(this.state.cityId == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "City is required.",
				showActivityIndicator: false
			})
			return
		}
		const members = []
		const addMembers = []
		const deleteMembers = []
		Object.values(this.state.members).forEach((v) => {
			if(v.position_id == 0) {
				deleteMembers.push(v)
			}
			else if(v.id == null) {
				addMembers.push(v)
			}
			else {
				members.push(v)
			}
		})
		const data = {
			cluster: {
				"date_formed": this.state.dateFormed,
				"cluster_name": this.state.clusterName,
				"region_id": this.state.user.region_id,
				"province_id": this.state.provinceId,
				"city_id": this.state.cityId,
				"site_id": this.state.siteId
			}
		}
		if(!this.state.shouldDisplayValues) {
			if(addMembers.length > 0) {
				data["members"] = addMembers
			}
			this.addCluster(data)
		}
		else {
			if(members.length > 0) {
				data["members"] = members
			}
			if(addMembers.length > 0) {
				data["add"] = {members: addMembers}
			}
			if(deleteMembers.length > 0) {
				data["delete"] = {members: deleteMembers}
			}
			this.editCluster(data)
		}
	}

	addCluster(data) {
		const apiReq = APIClusterRequest.addCluster(this.state.accessToken, data)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				clusterId: response.results.cluster_id,
				showInfoMessage: true,
				aMessage: response.status + "! " + this.state.clusterName.toUpperCase() + " " + response.description,
				submitAdd: false,
				showActivityIndicator: false
			})
			sessionStorage.setItem("cluster-id", response.results.cluster_id)
		})
	}

	editCluster(data) {
		const clusterId = sessionStorage.getItem("cluster-id")
		const apiReq = APIClusterRequest.editCluster(this.state.accessToken, data, clusterId)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + this.state.clusterName.toUpperCase() + " " + response.description,
				showActivityIndicator: false
			})
		})
	}

	eventHandler(e, compId, key, value) {
		if(this.state.servicesOffered == null) {
			this.state.servicesOffered = {}
		}
		this.state.servicesOffered[compId] = value
	}

	componentWillMount() {
		this.getProvinces()
		if(this.state.clusterId != null) {
			this.getFormValues()
		}
		else {
			this.getAllFarmersBySiteId([])
		}
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize.bind(this))
		this.setScrollable()
		this.setState({boardHeight: window.innerHeight * 0.5})
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize.bind(this))
	}

	onResize() {
		this.setScrollable()
		this.setState({boardHeight: window.innerHeight * 0.5})
	}

	setScrollable() {
		const sa = document.getElementById('cp-scroll-area')
		const ca = document.getElementById('cp-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+54) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	getFormValues() {
		this.setState({showActivityIndicator: true})
		const cluster = APIClusterRequest.getClusterById(this.state.accessToken, this.state.clusterId)
		cluster.then((response) => {
			console.log('getClusterById', response, this.state.clusterId)
			if(response.status === "FAILED") {
				this.getAllFarmersBySiteId([])
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			this.setMembers(response.results.members, (ms, memIds) => {
				const stateProps = ms
				stateProps["dateFormed"] = response.results.cluster.date_formed
				stateProps["clusterName"] = response.results.cluster.cluster_name
				stateProps["province"] = response.results.cluster.province
				stateProps["provinceId"] = response.results.cluster.province_id
				stateProps["city"] = response.results.cluster.city
				stateProps["cityId"] = response.results.cluster.city_id
				stateProps["showActivityIndicator"] = false
				this.setState(stateProps)
				this.getAllFarmersBySiteId(memIds)
			})
		})
	}

	setMembers(members, callback) {
		const sp = {}
		const memberCards = []
		const cLeader = []
		const cs = []
		const ct = []
		const cpc = []
		const cmc = []
		const memIds = []
		for(const v of members) {
			memIds.push(v.farmer_id)
			if(v.middle_name != null) {
				var mi = v.middle_name.charAt(0) + "."
			}
			const extn = (v.extension_name != null)? v.extension_name: ""
			const name = v.last_name + ", " + v.first_name + " " + extn + " " + mi
			switch(v.position_id) {
				case 2:
					cLeader.push(<Card id={v.registration_no+'-'+v.farmer_id+'-'+v.id}
						className="card" key={Math.random()} draggable={!this.state.isViewDetails}>
						{name.toUpperCase()}</Card>)
					break
				case 3:
					cs.push(<Card id={v.registration_no+'-'+v.farmer_id+'-'+v.id}
						className="card" key={Math.random()} draggable={!this.state.isViewDetails}>
						{name.toUpperCase()}</Card>)
					break
				case 4:
					ct.push(<Card id={v.registration_no+'-'+v.farmer_id+'-'+v.id}
						className="card" key={Math.random()} draggable={!this.state.isViewDetails}>
						{name.toUpperCase()}</Card>)
					break
				case 5:
					cpc.push(<Card id={v.registration_no+'-'+v.farmer_id+'-'+v.id}
						className="card" key={Math.random()} draggable={!this.state.isViewDetails}>
						{name.toUpperCase()}</Card>)
					break
				case 6:
					cmc.push(<Card id={v.registration_no+'-'+v.farmer_id+'-'+v.id}
						className="card" key={Math.random()} draggable={!this.state.isViewDetails}>
						{name.toUpperCase()}</Card>)
					break
				default:
					memberCards.push(<Card id={v.registration_no+'-'+v.farmer_id+'-'+v.id}
						className="card" key={Math.random()} draggable={!this.state.isViewDetails}>
						{name.toUpperCase()}</Card>)
			}
		}
		sp["memberCards"] = memberCards
		sp["leader"] = cLeader
		sp["secretary"] = cs
		sp["treasurer"] = ct
		sp["productionCoordinator"] = cpc
		sp["marketingCoordinator"] = cmc
		callback(sp, memIds)
	}

	getAllFarmersBySiteId(memIds) {
		const allFarmers = APIFarmerRequest.getAllFarmersBySiteId(this.state.accessToken, this.state.siteId)
		allFarmers.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const farmerCards = []
			const farmersList = {}
			response.results.rows.sort((a, b) => {
				return(a.last_name.localeCompare(b.last_name))
			})
			for(const v of response.results.rows) {
				if(memIds.includes(v.farmer_id)) {
					continue
				}
				const k = v.registration_no+'-'+v.farmer_id
				if(farmersList.hasOwnProperty(k)) {
					continue
				}
				if(v.middle_name != null) {
					var mi = v.middle_name.charAt(0)
				}
				const extn = (v.extension_name != null)? v.extension_name: ""
				const name = v.last_name + ", " + v.first_name + " " + extn + " " + mi
				farmerCards.push(<Card id={v.registration_no+'-'+v.farmer_id}
					className="card" key={Math.random()} draggable={!this.state.isViewDetails}>
					{name.toUpperCase()}</Card>)
				farmersList[v.registration_no+'-'+v.farmer_id] = name.toUpperCase()
			}
			this.setState({farmerCards: farmerCards, farmersList: farmersList})
		})
	}

	getProvinces() {
		const provs = JSON.parse(localStorage.getItem("provinces"))
		if(provs != null) {
			this.setState({provinces: provs})
			return
		}
		const province = APIGenericRequest.getAllProvincesByRegionId(this.state.accessToken, this.state.user.region_id)
		province.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.province_id, name: v.name})
			}
			localStorage.setItem("provinces", JSON.stringify(c))
			this.setState({
				provinces: c,
				province: "-- SELECT --",
				city: "-- SELECT --"
			})
		})
	}

	addMember(id, pid) {
		const fid = id.split('-')
		this.state.members[fid[1]] = {
			id: fid[2],
			farmer_id: fid[1],
			position_id: pid
		}
	}

	getAllBarangaysByCityId(id) {
		const city = APIGenericRequest.getAllBarangaysByCityId(this.state.accessToken, id)
		city.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.barangay_id, name: v.name})
			}
			this.setState({
				barangays: c,
				barangay: "-- ANY --"
			})
		})
	}

	onSearchEvent(value) {
		if(this.state.farmersList == null || value == null) {
			return
		}
		const farmerCards = []
		Object.entries(this.state.farmersList).map(([k, v]) => {
			if(k.includes(value.toUpperCase()) || v.includes(value.toUpperCase())) {
				farmerCards.push(<Card id={k} className="card"
					key={Math.random()} draggable={!this.state.isViewDetails}>{v}</Card>)
			}
		})
		this.setState({farmerCards: farmerCards})
	}

	archiveCluster() {
		const sites = APIClusterRequest.deleteClusterById(this.state.accessToken, this.state.clusterId)
		sites.then((response) => {
			console.log('deleteClusterById', response)
			if(response.status === "FAILED") {
				return
			}
			this.setState({
				showConfirmMessage: false,
				showInfoMessage: true,
				isViewDetails: true,
				aMessage: "Cluster " + this.state.clusterName + " has been archived."
			})
		})
	}

	render() {
		const b1Height = this.state.boardHeight - 42 + "px"
		const b2Height = this.state.boardHeight + 40 + "px"
		const view = <div id="cluster-profile">
			<div id="cp-scroll-area"><div id="cp-client-area">
				<div className="title-bar">CLUSTER INFO</div>
				<div id="cell"><div id="cp-cell1">
					<div id="cp-cell1-r1-i1">
						<div>Cluster Name</div>
						<input type="text" value={this.state.clusterName} onChange={(e) => {
							this.setState({clusterName: e.target.value})
						}} disabled={this.state.isViewDetails} />
					</div>
					<div id="cp-cell1-r1-i2">
						<div>Date Formed</div>
						<DatePicker value={this.state.dateFormed} onChange={(value) => {
							this.setState({dateFormed: value})
						}} max={this.state.dateToday} disabled={this.state.isViewDetails} />
					</div>
					<div id="cp-cell1-r2-i1">
						<div style={{'margin-bottom': '5px'}}>Province</div>
						<DropdownWidget list={this.state.provinces} placeholder={this.state.province} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								this.setState({provinceId: id})
								const province = APIGenericRequest.getAllCitiesByProvinceId(this.state.accessToken, id)
								province.then((response) => {
									if(response.status === "FAILED") {
										return
									}
									const c = []
									for(const v of response.results.rows) {
										c.push({id: v.city_id, name: v.name})
									}
									this.setState({
										cities: c,
										city: "-- SELECT --"
									})
								})
							}} disabled={this.state.isViewDetails} />
					</div>
					<div id="cp-cell1-r2-i2">
						<div style={{'margin-bottom': '5px'}}>Municipality</div>
						<DropdownWidget list={this.state.cities} placeholder={this.state.city} cStyle={{"width": "100%"}}
							onItemSelected={(id, val) => {
								this.setState({cityId: id})
								this.getAllBarangaysByCityId(id)
							}} disabled={this.state.isViewDetails} />
					</div>
				</div></div>
				<div className="title-bar">CLUSTER MEMBERSHIP</div>
				<div id="cp-cell3">
					<div id="cp-cell3-c1">
						<div className="lbl-board">FARMERS</div>
						<InputSearchWidget placeholder="SEARCH" cStyle={{'width': '100%', 'margin-top': '10px'}}
							onSearchClick={(value) => {
								this.onSearchEvent(value)
							}}
							onEnterPress={(value) => {
								this.onSearchEvent(value)
							}}
						/>
						<div id="cell-board1">
							<Board id="board-1" className="board" onCardAdded={(card) => {
								this.addMember(card.id, "0")
							}} style={{style: b1Height}} list={this.state.farmerCards}
								draggable={!this.state.isViewDetails}></Board>
						</div>
					</div>
					<div id="cp-cell3-c2">
						<div className="lbl-board">MEMBERS</div>
						<div id="cell-board2">
							<Board id="board-2" className="board" onCardAdded={(card) => {
								if(card.pid === 'board-1') {
									let memberCards = this.state.memberCards
									if(memberCards == null) {
										memberCards = []
									}
									memberCards.push(<Card id={card.id}
										className="card"
										key={Math.random()}
										draggable={!this.state.isViewDetails}>
											{card.name}
										</Card>)
									const farmerCards = []
									const farmersList = {}
									Object.entries(this.state.farmersList).map(([k, v]) => {
										if(!card.id.includes(k)) {
											farmerCards.push(<Card id={k} className="card"
												key={Math.random()} draggable={!this.state.isViewDetails}>{v}</Card>)
												farmersList[k] = v
										}
									})
									this.setState({
										farmerCards: farmerCards,
										farmersList: farmersList,
										memberCards: memberCards
									})
								}
								this.addMember(card.id, "1")
							}} style={{style: b2Height}} list={this.state.memberCards}></Board>
						</div>
					</div>
					<div id="cp-cell3-c3">
						<div className="lbl-board">CLUSTER OFFICERS</div><div>
							<div>Cluster Leader</div>
							<div id="cell-board4">
								<Board id="board-3" className="board" limit={1} onCardAdded={(card) => {
									if(card.pid === 'board-1') {
										let leader = this.state.leader
										if(leader == null) {
											leader = []
										}
										leader.push(<Card id={card.id}
											className="card"
											key={Math.random()}
											draggable={!this.state.isViewDetails}>
												{card.name}
											</Card>)
										const farmerCards = []
										const farmersList = {}
										Object.entries(this.state.farmersList).map(([k, v]) => {
											if(!card.id.includes(k)) {
												farmerCards.push(<Card id={k} className="card"
													key={Math.random()} draggable={!this.state.isViewDetails}>{v}</Card>)
													farmersList[k] = v
											}
										})
										this.setState({
											farmerCards: farmerCards,
											farmersList: farmersList,
											leader: leader
										})
									}
									this.addMember(card.id, "2")
								}} list={this.state.leader} />
						</div></div>
						<div>
							<div>Secretary</div>
							<div id="cell-board5">
								<Board id="board-4" className="board" limit={1} onCardAdded={(card) => {
									if(card.pid === 'board-1') {
										let secretary = this.state.secretary
										if(secretary == null) {
											secretary = []
										}
										secretary.push(<Card id={card.id}
											className="card"
											key={Math.random()}
											draggable={!this.state.isViewDetails}>
												{card.name}
											</Card>)
										const farmerCards = []
										const farmersList = {}
										Object.entries(this.state.farmersList).map(([k, v]) => {
											if(!card.id.includes(k)) {
												farmerCards.push(<Card id={k} className="card"
													key={Math.random()} draggable={!this.state.isViewDetails}>{v}</Card>)
													farmersList[k] = v
											}
										})
										this.setState({
											farmerCards: farmerCards,
											farmersList: farmersList,
											secretary: secretary
										})
									}
									this.addMember(card.id, "3")
								}} list={this.state.secretary} />
							</div>
						</div>
						<div>
							<div>Treasurer</div>
							<div id="cell-board6">
								<Board id="board-5" className="board" limit={1} onCardAdded={(card) => {
									if(card.pid === 'board-1') {
										let treasurer = this.state.treasurer
										if(treasurer == null) {
											treasurer = []
										}
										treasurer.push(<Card id={card.id}
											className="card"
											key={Math.random()}
											draggable={!this.state.isViewDetails}>
												{card.name}
											</Card>)
										const farmerCards = []
										const farmersList = {}
										Object.entries(this.state.farmersList).map(([k, v]) => {
											if(!card.id.includes(k)) {
												farmerCards.push(<Card id={k} className="card"
													key={Math.random()} draggable={!this.state.isViewDetails}>{v}</Card>)
													farmersList[k] = v
											}
										})
										this.setState({
											farmerCards: farmerCards,
											farmersList: farmersList,
											treasurer: treasurer
										})
									}
									this.addMember(card.id, "4")
								}} list={this.state.treasurer} />
							</div>
						</div>
						<div>
							<div>Production Coordinator</div>
							<div id="cell-board7">
								<Board id="board-6" className="board" limit={1} onCardAdded={(card) => {
									if(card.pid === 'board-1') {
										let productionCoordinator = this.state.productionCoordinator
										if(productionCoordinator == null) {
											productionCoordinator = []
										}
										productionCoordinator.push(<Card id={card.id}
											className="card"
											key={Math.random()}
											draggable={!this.state.isViewDetails}>
												{card.name}
											</Card>)
										const farmerCards = []
										const farmersList = {}
										Object.entries(this.state.farmersList).map(([k, v]) => {
											if(!card.id.includes(k)) {
												farmerCards.push(<Card id={k} className="card"
													key={Math.random()} draggable={!this.state.isViewDetails}>{v}</Card>)
													farmersList[k] = v
											}
										})
										this.setState({
											farmerCards: farmerCards,
											farmersList: farmersList,
											productionCoordinator: productionCoordinator
										})
									}
									this.addMember(card.id, "5")
								}} list={this.state.productionCoordinator} />
							</div>
						</div>
						<div>
							<div>Marketing Coordinator</div>
							<div id="cell-board8">
								<Board id="board-7" className="board" limit={1} onCardAdded={(card) => {
									if(card.pid === 'board-1') {
										let marketingCoordinator = this.state.marketingCoordinator
										if(marketingCoordinator == null) {
											marketingCoordinator = []
										}
										marketingCoordinator.push(<Card id={card.id}
											className="card"
											key={Math.random()}
											draggable={!this.state.isViewDetails}>
												{card.name}
											</Card>)
										const farmerCards = []
										const farmersList = {}
										Object.entries(this.state.farmersList).map(([k, v]) => {
											if(!card.id.includes(k)) {
												farmerCards.push(<Card id={k} className="card"
													key={Math.random()} draggable={!this.state.isViewDetails}>{v}</Card>)
													farmersList[k] = v
											}
										})
										this.setState({
											farmerCards: farmerCards,
											farmersList: farmersList,
											marketingCoordinator: marketingCoordinator
										})
									}
									this.addMember(card.id, "6")
								}} list={this.state.marketingCoordinator} />
							</div>
						</div>
					</div>
				</div>
			</div>
				</div>
				<div className="alternate-footer"><OrgFooter submit={this.onSubmit}
					showDissolve={true}
					showSubmit={true}
					eventHandler={(e) => {
						console.log(e.value)
						this.setState({
							showConfirmMessage: true,
							aMessage: "Are you sure you want to archive this cluster?"
						})
						{/* this.archiveCluster() */}
					}}
					disabled={this.state.isViewDetails}
				/></div>
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false, shouldDisplayValues: true})
					this.props.submit()
			}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					if(e.target.innerHTML === "NO") {
						this.setState({showConfirmMessage: false})
					}
					else {
						this.archiveCluster()
					}
				}}
			/>}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

export default ClusterProfile
